import { ClipboardModule } from '@angular/cdk/clipboard';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { PlatformModule } from '@angular/cdk/platform';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { BibliothequeComponent } from '@app/features/editeur/components/sidebar/bibliotheque/bibliotheque.component';
import { CreerObjetMaquetteComponent } from '@app/features/editeur/components/sidebar/creer-objet-maquette/creer-objet-maquette.component';
import { DescripteursContexteComponent } from '@app/features/editeur/components/sidebar/editeur-objet-maquette/descripteurs-contexte/descripteurs-contexte.component';
import { DescripteursEnqueteComponent } from '@app/features/editeur/components/sidebar/editeur-objet-maquette/descripteurs-enquete/descripteurs-enquete.component';
import { DescripteursFormatEnseignementsComponent } from '@app/features/editeur/components/sidebar/editeur-objet-maquette/descripteurs-format-enseignements/descripteurs-format-enseignements.component';
import { DescripteursObjetMaquetteComponent } from '@app/features/editeur/components/sidebar/editeur-objet-maquette/descripteurs-objet-maquette/descripteurs-objet-maquette.component';
import { DescripteursSyllabusComponent } from '@app/features/editeur/components/sidebar/editeur-objet-maquette/descripteurs-syllabus/descripteurs-syllabus.component';
import { EditeurObjetMaquetteComponent } from '@app/features/editeur/components/sidebar/editeur-objet-maquette/editeur-objet-maquette.component';

import { LimitInputValueDirective } from '@app/shared/directives/limit-input-value.directive';
import { EspaceIndicatorComponent } from '@app/shared/espace-indicator/espace-indicator.component';

import { ListModule } from '@app/shared/list/list.module';
import { MinutesToHhMmPipe } from '@app/shared/pipes/minutes-to-hh-mm.pipe';
import { SelectNomenclatureComponent } from '@app/shared/select-nomenclature/select-nomenclature/select-nomenclature.component';

import { NgxGraphModule } from '@swimlane/ngx-graph';
import { EditeurComponent } from './components/editeur.component';
import { GraphComponent } from './components/graph/graph.component';
import { ResultatsRecuperationFormationsPorteusesDialogComponent } from './components/resultats-recuperation-formations-porteuses-dialog/resultats-recuperation-formations-porteuses-dialog.component';
import { SelectMultipleStructuresComponent } from './components/sidebar/editeur-objet-maquette/descripteurs-format-enseignements/select-multiple-structures/select-multiple-structures.component';
import { VolumeHoraireInputComponent } from './components/sidebar/editeur-objet-maquette/descripteurs-format-enseignements/volume-horaire-input/volume-horaire-input.component';
import { PerimetresComponent } from './components/sidebar/editeur-objet-maquette/perimetres/perimetres.component';
import { SidebarComponent } from './components/sidebar/sidebar/sidebar.component';
import { ToolboxComponent } from './components/toolbox/toolbox.component';
import { MaquetteNoeudComponent } from './components/treeview/maquette-noeud/maquette-noeud.component';
import { TreeviewComponent } from './components/treeview/treeview.component';
import { EditeurRoutingModule } from './editeur-routing.module';

@NgModule({
    imports: [
        CommonModule,
        EditeurRoutingModule,
        MatCardModule,
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        MatTabsModule,
        MatMenuModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatBadgeModule,
        MatTreeModule,
        DragDropModule,
        MatRadioModule,
        MatSelectModule,
        MatSlideToggleModule,
        ListModule,
        ClipboardModule,
        ScrollingModule,
        MatButtonToggleModule,
        MatChipsModule,
        MatProgressSpinnerModule,
        MatDividerModule,
        MatSidenavModule,
        MatAutocompleteModule,
        NgxGraphModule,
        MatChipsModule,
        PlatformModule,
        MinutesToHhMmPipe,
        NgxGraphModule,
        EspaceIndicatorComponent,
        SelectNomenclatureComponent,
        ResultatsRecuperationFormationsPorteusesDialogComponent,
        EditeurComponent,
        ToolboxComponent,
        TreeviewComponent,
        EditeurObjetMaquetteComponent,
        MaquetteNoeudComponent,
        BibliothequeComponent,
        CreerObjetMaquetteComponent,
        DescripteursObjetMaquetteComponent,
        DescripteursEnqueteComponent,
        DescripteursContexteComponent,
        DescripteursSyllabusComponent,
        DescripteursFormatEnseignementsComponent,
        GraphComponent,
        SelectMultipleStructuresComponent,
        VolumeHoraireInputComponent,
        LimitInputValueDirective,
        SidebarComponent,
        PerimetresComponent
    ]
})
export class EditeurModule {}
